import throttle from 'lib/function/throttle'
import { useEffect, useState } from 'react'

function useOnScreen(
  startElement: HTMLElement | null,
  endElement: HTMLElement | null,
  rootMargin: number = 0,
  rootMarginBottom: number = 0,
  height: number = 0,
): boolean {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    let cancelled = false

    const handleScroll = () => {
      // throttle's trailing invocation can still fire after cleanup has already run
      // (it's scheduled via its own setTimeout, independent of the listener removal below)
      if (cancelled) {
        return
      }
      if (startElement && endElement) {
        if (startElement.getBoundingClientRect().top + rootMargin <= 0 && (endElement.getBoundingClientRect()?.top - rootMarginBottom >= 0 || (height && startElement.getBoundingClientRect().bottom + height >= 0))) {
          setIntersecting(true)
        } else {
          setIntersecting(false)
        }
      }
    }

    const throttledHandleScroll = throttle(handleScroll, 200, { leading: true, trailing: true })
    window.addEventListener('scroll', throttledHandleScroll)

    return () => {
      cancelled = true
      window.removeEventListener('scroll', throttledHandleScroll)
    }
  }, [startElement, endElement, rootMargin, height, rootMarginBottom])

  return isIntersecting
}

export default useOnScreen
